import { TIER_ORDER, TIER_META } from "../lib/tiers";

export const TierSwitch = ({ value, onChange, mine = [], className = "" }) => (
  <div data-testid="tier-switch" className={`flex flex-wrap gap-2 ${className}`}>
    {TIER_ORDER.map((t) => {
      const { short, icon: Icon } = TIER_META[t];
      const on = value === t;
      return (
        <button key={t} data-testid={`tier-${t}`} onClick={() => onChange(t)}
          className={`px-4 py-2 rounded-full text-sm border inline-flex items-center gap-2 transition-colors ${on ? "bg-[#38BDF8] text-[#0B0F19] border-[#38BDF8]" : "border-white/10 text-slate-300 hover:border-[#38BDF8]"}`}>
          <Icon className="w-3.5 h-3.5" />{short}
          {mine.includes(t) && <span className={`w-1.5 h-1.5 rounded-full ${on ? "bg-[#0B0F19]" : "bg-emerald-400"}`} />}
        </button>
      );
    })}
  </div>
);
